module.exports = __webpack_public_path__ + "static/home_03_mobile-66f2f789dc32723f5af5d657473d2ca8.webp";